import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SideBarService {
    private isOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    private isOpenAtIndex: BehaviorSubject<number> = new BehaviorSubject<number>(-1);
    isOpen$ = this.isOpen.asObservable();
    isOpenAtIndex$ = this.isOpenAtIndex.asObservable();

    toggle() {
        this.isOpen.next(!this.isOpen.value);
    }

    open() {
        this.isOpen.next(true);
    }

    close() {
        this.isOpen.next(false);
    }

    openAtIndex(index: number) {
        this.isOpenAtIndex.next(index);
    }
}
